import React from 'react';
import Button from 'components/Button';
import { Typography, TypographyVariant } from 'components/Typography';
import Markdown from 'components/Markdown';
import { getTypographyForMarkdown } from 'lib/getTypographyForMarkdown';
import { FORM_NAME } from '../../../../constants';
import './multiFactorAuthWrapper.css';

const typographyForMarkdown = getTypographyForMarkdown(TypographyVariant.BodyMd);

interface MultiFactorAuthFormProps {
  isLoading?: boolean;
  isSubmitDisabled?: boolean;
  onSubmit?: () => void;
  buttonText: string;
  title: string;
  body?: string;
  children?: React.ReactNode;
}

export const MultiFactorAuthWrapper = ({
  isLoading,
  onSubmit,
  buttonText,
  title,
  body,
  children,
  isSubmitDisabled
}: MultiFactorAuthFormProps) => (
  <form name={FORM_NAME} onSubmit={onSubmit} className="multiFactorAuthWrapper">
    <Typography variant={TypographyVariant.BodyMdStrong}>
      <p>{title}</p>
    </Typography>
    {body && <Markdown content={body} renderers={typographyForMarkdown} />}
    {children}
    <div className="fieldset fieldset--centerflex">
      <Button
        disabled={isSubmitDisabled}
        loading={isLoading}
        buttonText={buttonText}
        className="button--fullWidth"
        type="submit"
      />
    </div>
  </form>
);
